var map = {
	"./1.jpg": "25df",
	"./2.jpg": "4c14",
	"./3.jpg": "6cf9",
	"./4.jpg": "8d26",
	"./5.jpg": "4735",
	"./6.jpg": "fc27"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0cb2";